export default {
      id: "pattern-mutmut-image-usage",
      viewBox: "0 0 283 283",
      url: "../icon/" + "icons.svg#pattern-mutmut-image-usage",
      toString: function () {
        return this.url;
      }
    }